import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineReject = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M8 14.825a6.825 6.825 0 1 1 0-13.65 6.825 6.825 0 0 1 0 13.65M10.625 10.625l-5.25-5.25" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineReject;
